var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.54,
    height: 12.54,
    viewBox: "0 0 12.54 12.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-ico",
    transform: "translate(6.297 2) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    y1: 6.077,
    x2: 6,
    fill: "none",
    stroke: "#1c414f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_11",
    "data-name": "Ligne 11",
    x1: 6,
    y1: 6.077,
    fill: "none",
    stroke: "#1c414f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIco);
export default __webpack_public_path__ + "static/media/plus-ico.695812dfec99dffe3c25fe0071230583.svg";
export { ForwardRef as ReactComponent };